<template>
  <div>
    <div class="head">
      <h2 v-for="(item, index) in subjectTypeList" :key="index">
        <div v-if="item.value === type">
          <span>{{item.label}} </span>
          <span v-if="!isShow" class="socre" @click="handClickDialog(item.label)">批量设置分数</span>
          <span v-if="isShow" class="tips">( {{ subjectDetailList.length }}题 共{{ totalScore }} 分 )</span>
        </div>
      </h2>
    </div>
    <div class="content" v-for="(item, index) in subjectDetailList" :key="index">
      <div class="title">
          <div>
            <span>{{index+1 + '. '+ item.content}}</span>
          </div>
          <div class="image" v-if="item.pictureUrl">
            <img :ref="'imageUrlOptions' + index" class="image-url-options" :src="item.pictureUrl">
          </div> 
      </div>
      <div class="body">
        <el-radio-group v-if="type === subjectTypeMap.single.value">
          <div class="content-radio" v-for="(item, index) in item.choices" :key="index">
            <el-radio disabled :label="item.flag">
              <div>
                {{item.flag + " " + item.content}}
              </div>
              <div class="image" v-if="item.pictureUrl">
                <img :ref="'imageUrlOptions' + index" class="image-url-options" :src="item.pictureUrl">
              </div>  
            </el-radio>
          </div>
        </el-radio-group>
        <el-checkbox-group v-if=" type === subjectTypeMap.mutiple.value">
          <div class="content-radio" v-for="(item, index) in item.choices" :key="index">
            <el-checkbox disabled :label="item.flag">
              <div>
              {{item.flag + " " + item.content}}
              </div>
              <div class="image" v-if="item.pictureUrl">
                <img :ref="'imageUrlOptions' + index" class="image-url-options" :src="item.pictureUrl">
              </div>  
            </el-checkbox>
          </div>
        </el-checkbox-group>
        <el-radio-group v-if="type === subjectTypeMap.judgement.value">
          <div class="content-radio" v-for="(item, index) in item.choices" :key="index">
            <el-radio disabled :label="item.flag">
              <div>
                {{item.flag + " " + item.content}}
              </div>
              <div class="image" v-if="item.pictureUrl">
                <img :ref="'imageUrlOptions' + index" class="image-url-options" :src="item.pictureUrl">
              </div>
            </el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="footer" v-if="!isShow">
        <el-row>
          <el-col :span="12">
            <span style="color: red;">*</span>
            分值：
            <el-input-number v-model="item.score" 
              :step="1" :min="0" :precision="1" size="mini" 
              controls-position="right" @change="changeVal($event, index)"></el-input-number>
          </el-col>
          <el-col :span="12" style="text-align: right;">
            <span :class="index !==0 ? 'active' : 'disabled'" @click="moveUp(index)">上移</span>
            <span> | </span>
            <span :class="index !==subjectDetailList.length-1 ? 'active' : 'disabled'" @click="moveDown(index)">下移</span>
            <span> | </span>
            <span class="active" @click="optionDel(index)">删除</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <hr style="border: solid 1px #d9d9d9;margin: 15px 0 15px 0;">
    <el-dialog
      :visible.sync="subjectScoreDialogVisible"
      :title="typeLabel"
      width="600px"
      :destroy-on-close="true"
      @close="closeDialog">
      <el-row>
        <el-col :span="12">
          <span style="color: red;">*</span>
          分值：
          <el-input-number v-model="subjectScore" 
            :step="1" :min="0" :precision="1" size="mini" 
            controls-position="right"></el-input-number>
        </el-col>
      </el-row>
      <span slot="footer">
        <template>
          <el-button @click="closeDialog">取消</el-button>
          <el-button class="article-submit-btn" type="primary" @click="setSubjectScore">确认</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { subjectTypeList, subjectTypeMap } from '@/const/crud/app/subject-lib'

export default {
  name: 'subject-component',
  props: {
    subjectDetailList: {
      type: Array
    },
    type: {
      type: Number
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subjectTypeList,
      subjectTypeMap,
      subjectScoreDialogVisible: false,
      typeLabel: '',
      subjectScore: 0,
      totalScore: 0,
    }
  },
  created() {
  },
  mounted() {
    if (this.isShow) {
      let scoreList = this.subjectDetailList.map(item => item.score)
      this.totalScore = scoreList.reduce((a, b) => a + b) ? scoreList.reduce((a, b) => a + b) : 0
    }
  },
  methods: {
    moveUp(index){
      if (index > 0) {
        let tempOption = this.subjectDetailList[index - 1];
        this.$set(this.subjectDetailList, index - 1, this.subjectDetailList[index]);
        this.$set(this.subjectDetailList, index, tempOption)
      }
    },
    moveDown(index){
      if (index < this.subjectDetailList.length-1) {
        let tempOption = this.subjectDetailList[index + 1];
        this.$set(this.subjectDetailList, index + 1, this.subjectDetailList[index]);
        this.$set(this.subjectDetailList, index, tempOption)
      }
    },
    optionDel(index) {
      this.subjectDetailList.splice(index, 1);
    },
    changeVal(event, index) {
      this.$emit('setScore', {value: this.subjectDetailList[index], index: index, type: this.type})
      this.$forceUpdate();
    },
    handClickDialog(label) {
      this.typeLabel = '批量设置分数 (' + label + ')' 
      this.subjectScoreDialogVisible = true;
    },
    closeDialog() {
      this.subjectScoreDialogVisible = false;
    },
    setSubjectScore() {
      this.subjectDetailList.forEach((item, index) => {
        item.score = this.subjectScore;
        this.$emit('setScore', {value: item, index: index, type: this.type})
      })
      this.closeDialog();
    },
  },
}
</script>

<style lang="scss" scoped>

.content {
  &-radio {
    margin-top: 15px;
  }
  .title {
    margin-top: 15px;
    display: flex;
    align-items: center;
  }
}
.socre {
  font-size: 14px;
  color: #5398f3;
  cursor: pointer;
}
.tips {
  padding-left: 15px;
  font-size: 14px;
  color: #888888;
}
.footer {
  margin-top: 15px;
  .active {
    color: #409EFF;
    cursor: pointer;
  }
  .disabled {
    color: #d9d9d9;
  }
}
.image {
  display: inline;
  padding: 0;

  .image-url-options{
    width: 62px;
    height: 62px;
    border-radius: 6px;
    margin-right: 8px;
    float: left;
    object-fit: cover;
  }
}
/deep/.el-radio {
  display: flex;
}
</style>
